import { render, staticRenderFns } from "./MultiAsset.vue?vue&type=template&id=773a962c&"
import script from "./MultiAsset.vue?vue&type=script&lang=js&"
export * from "./MultiAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports